export default __webpack_public_path__ + "90a59a5af878d2f93dbc0c3f6b212eea.png";